module.exports = __webpack_public_path__ + "img/001-word.2b6b10c8.svg";